/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  categoryList: [],       // 대유형 목록
  mainCategoryList: [],   // 중유형 목록
  subCategoryList: [],    // 소유형 목록
  activeCategory: {},     // 선택된 대유형
  activeMainCategory: {}, // 선택된 중유형
  activeSubCategory: {}, // 선택된  소유형
  activeCurriculum: null,
  activeGradeId: null,
  activeSubjectTypeId: null,
  activeSubjectDetailTypeId: null,
  conceptBookData: {},

  // ✅ 목차별 생성용 데이터
  publisherList: [],
  textbookPublisherList: [],
  textbookSubjectList: [],
  activeTextbook: {},
  textbookContentList: [],
  textbookContentMainList: [],
  textbookContentSubList: [],

  // ✅ 편집기 상태 저장 (뒤로가기 시 복원용)
  categoryEditorState: {
    selected: null,              // { curriculum, schoolType, subject, detailSubject }
    categoryTree: null,         // 트리 데이터
    expandedStates: null,       // 펼침 상태
    scrollTop: 0,               // 스크롤 위치
    lastVisitedCategoryInfo: null, // 마지막 방문 정보
  },
  contentEditorState: {
    selected: null,              // { publisher, school, grade, textbookType, textbook }
    contentTree: null,           // 트리 데이터
    expandedStates: null,        // 펼침 상태
    scrollTop: 0,                // 스크롤 위치
    lastVisitedContentInfo: null, // 마지막 방문 정보
  },

}
